import { PublicClientApplication } from "@azure/msal-browser";
import { AthenaGroupId, HAIGroupId, HAIGroupIdProd, checkGroupsApi, msal } from "commonConstants";

export const msalConfig = {
  auth: {
    clientId: msal.clientId,
    authority: msal.authority,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
};

export const logoutMSAL = () => {
  return msalInstance.logoutRedirect();
};

// To check user access from microsoft graph Api
export const getGroupInfo = async (token) => {
  const currentENV = process.env.REACT_APP_ENV;
  const payload = {
    groupIds: [
      currentENV === "PROD" ? HAIGroupIdProd : HAIGroupId, //HAI
      AthenaGroupId, // athena
    ],
  };
  if (token) {
    const groupInfo = await fetch(checkGroupsApi, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
      body: JSON.stringify(payload),
    }).then((response) => response.json());
    return groupInfo;
  }
};
